import {IS_MOBILE, SET_REF} from './configurationActionTypes';

export function switchMobile(isMobile) {
  return dispatcher => dispatcher({type: IS_MOBILE, payload: isMobile});
}

export function setRef(ref) {
  return dispatcher => dispatcher({type: SET_REF, payload: ref});
}

export default {switchMobile, setRef};
